import { UserType } from 'redux/auth/types';
import { ViewMode } from 'redux/records/types';
import { RecordAccessLevel } from 'data-types';
import { IAppState } from './types';

const initialState: IAppState = {
  menu: {
    showOverview: false,
    menuOpen: false,
    anchorEl: null,
    menuSelectedPage: null,
  },
  auth: {
    isAuthenticated: false,
    userType: UserType.Initial,
    JWT: null,
    userId: null,
    userName: null,
    email: null,
  },
  websockets: {
    isConnected: false,
    isAppVisible: true,
    connectionsAndUsernames: [],
    showConnections: false,
    lastConnectionsTimestamp: '',
    lastConnectionsTimestampISO: '',
  },
  crud: {
    createCommand: null,
    readCommand: null,
    updateCommand: null,
    deleteCommand: null,
  },
  llmProfiles: {
    llmProfiles: [],
    currentLLMProfileId: null,
    showLLMProfileForm: false,
    llmProfileForm: {
      id: '',
      description: '',
      model_id: '',
      errors: {},
    },
  },
  records: {
    isInitialLoadInProgress: false,
    latestPublicRecords: [],
    records: [],
    currentRecordId: null,
    viewMode: ViewMode.SHOW_FORM,
    recordForm: {
      id: '',
      user_text: '',
      llm_profile_id: '',
      access_level: RecordAccessLevel.Private,
      errors: {},
      uploadedFiles: [],
      shareWithSaasTenantIds: [],
    },
    showSummaries: false,
    showAllLinkable: false,
    searchText: '',
    searchType: undefined,
    includeArchived: false,
    selectedSummariesRecordId: null,
    processingStartTimes: {},
    maximizedRecords: {},
  },
  subrecords: {
    subrecords: {},
  },
  saasTenants: {
    saasTenants: [],
    searchResults: [],
    searchTooManyResults: false,
  },
  summaries: {
    summaries: [],
    loading: false,
    error: null,
    selectedSummary: null,
  },
  analytics: {
    analyticsData: [],
    usageMetricsData: [],
  },
};

export default initialState;
